export const AppConfig = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  REACT_APP_WS_API_URL: process.env.REACT_APP_WS_API_URL,
  STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_PUBLISHABLE_KEY,
  REACT_APP_AMPLITUDE_KEY: process.env.REACT_APP_AMPLITUDE_KEY || '',
  REACT_APP_INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_APP_ID || '',
  REACT_APP_TRACK_GOOGLE_ANALYTICS: process.env.REACT_APP_TRACK_GOOGLE_ANALYTICS,
  REACT_APP_START_MAINTENANCE_TIMESTAMP: process.env.REACT_APP_END_MAINTENANCE_TIMESTAMP,
  REACT_APP_END_MAINTENANCE_TIMESTAMP: process.env.REACT_APP_END_MAINTENANCE_TIMESTAMP,
  // The embedded Textbook (Reader) app. Must stay on the traineracademy.org registrable domain —
  // the reader's session cookie is only first-party inside our iframe while it does.
  READER_ORIGIN: process.env.REACT_APP_READER_ORIGIN || 'https://read.traineracademy.org',
  // Debug-only affordances (the onboarding replay). Never set in the production project.
  ENABLE_DEBUG_TOOLS: process.env.REACT_APP_ENABLE_DEBUG_TOOLS === 'true',
};
